import { Link } from 'react-router-dom';
import { allSections, getArticlesBySection } from '@/utils/content';

export default function CategorySection() {
  return (
    <section id="sections" className="w-full scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.25em] text-primary-600">板块导航</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              五个分区，各有各的瓜田
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              按娱乐、社会、科技、体育、网红圈做板块分区，点进对应分区就能看那一堆的最近八卦和话题更新。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5 lg:gap-5">
          {allSections.map((section, index) => {
            const count = getArticlesBySection(section.slug).length;
            return (
              <Link
                key={section.slug}
                to={`/section/${section.slug}`}
                className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-lg ${
                    index % 3 === 0
                      ? 'bg-primary-100 text-primary-700'
                      : index % 3 === 1
                        ? 'bg-secondary-100 text-secondary-800'
                        : 'bg-accent-100 text-accent-800'
                  }`}
                >
                  <i className={`${section.icon} text-2xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{section.name}</h3>
                <p className="mt-1 text-xs text-foreground-500">{section.tagline}</p>
                <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {section.description}
                </p>
                <span className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span>共 {count} 篇整理</span>
                  <span className="flex items-center gap-1 font-medium text-primary-600">
                    进入分区 <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}